<cm-add-item-dialog [title]="title" [confirmButtonText]="confirmButtonText" [confirmDisabled]="!isFormValid" [isLoading]="$isLoading()" (confirm)="onConfirm()">
    <div cm-dialog-content class="cm-edit-task-type-form">
        <cm-input-container>
            <ng-container cm-inline-label>Task Type:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="data.taskTypeInfo.taskType" (valueChange)="data.taskTypeInfo.taskType = $event"></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Queue Group:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="data.taskTypeInfo.queueGroup" (valueChange)="data.taskTypeInfo.queueGroup = $event"></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Endpoint:</ng-container>
            <ng-container cm-input>
                <cm-string-input [value]="data.taskTypeInfo.endpoint ?? ''" (valueChange)="data.taskTypeInfo.endpoint = $event"></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Invocation Method:</ng-container>
            <ng-container cm-input>
                <mat-select placeholder="Invocation method" [(ngModel)]="data.taskTypeInfo.invocationMethod" name="invocationMethod">
                    @for (invocationType of Labels.InvocationMethod.values(); track invocationType.state) {
                        <mat-option [value]="invocationType.state">
                            {{ invocationType.label }}
                        </mat-option>
                    }
                </mat-select>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Default Timeout (seconds):</ng-container>
            <ng-container cm-input>
                <cm-string-input
                    [value]="data.taskTypeInfo.defaultTimeout?.toString() ?? ''"
                    (valueChange)="data.taskTypeInfo.defaultTimeout = $event ? +$event : undefined"
                ></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Max Timeout (seconds):</ng-container>
            <ng-container cm-input>
                <cm-string-input
                    [value]="data.taskTypeInfo.maxTimeout?.toString() ?? ''"
                    (valueChange)="data.taskTypeInfo.maxTimeout = $event ? +$event : undefined"
                ></cm-string-input>
            </ng-container>
        </cm-input-container>

        <cm-input-container>
            <ng-container cm-inline-label>Cancel Timeout (seconds):</ng-container>
            <ng-container cm-input>
                <cm-string-input
                    [value]="data.taskTypeInfo.cancelTimeout?.toString() ?? ''"
                    (valueChange)="data.taskTypeInfo.cancelTimeout = $event ? +$event : undefined"
                ></cm-string-input>
            </ng-container>
        </cm-input-container>

        @if (data.edit) {
            <div class="cm-delete-section">
                <button mat-button [matMenuTriggerFor]="deleteMenu" type="button">Delete Task Type</button>
            </div>
        }
    </div>
</cm-add-item-dialog>

<mat-menu #deleteMenu="matMenu">
    <button mat-menu-item (click)="onDelete()">
        <span>Delete task type</span>
    </button>
</mat-menu>
